// Auswahl und Darstellung des Geltungsbereichs einer Totara-Einstellung.
//
// Fachlich gibt es drei sich ausschließende Stufen:
//   global            – gilt für die gesamte Totara-Instanz
//   Kursset           – gilt für alle Mandanten dieses Kurssets
//                       (Standard bzw. Sülzle, Weinmann Aach, Carl Spaeter)
//   einzelner Mandant – gilt nur für diesen Mandanten
//
// Im DOM lässt sich das nur über EINEN Select-Wert abbilden, deshalb
// kodieren wir die Stufe in den Wert ('', 'set:<name>', 'mandant:<id>').
// Die Kodierung bleibt in dieser Datei gekapselt; nach außen wird immer
// mit { mandant_id, course_set } gearbeitet – so wie es die API erwartet.

import { courseSetLabel } from '../courseSets.js';

/** { mandant_id, course_set } → Select-Wert. */
export function encodeScope({ mandant_id, course_set }) {
    if (mandant_id !== null && mandant_id !== undefined && mandant_id !== '') {
        return `mandant:${mandant_id}`;
    }
    if (course_set) return `set:${course_set}`;
    return '';
}

/** Select-Wert → { mandant_id, course_set } für die API. */
export function decodeScope(value) {
    if (value && value.startsWith('mandant:')) {
        return { mandant_id: Number(value.slice('mandant:'.length)), course_set: null };
    }
    if (value && value.startsWith('set:')) {
        return { mandant_id: null, course_set: value.slice('set:'.length) };
    }
    return { mandant_id: null, course_set: null };
}

/** Lesbare Beschriftung für Listen und Kopfzeilen. */
export function formatScope(setting) {
    if (setting.mandant_id) return setting.mandant_name || `Mandant #${setting.mandant_id}`;
    if (setting.course_set) return `Kursset: ${setting.course_set}`;
    return 'global';
}

/**
 * Ein Select über alle drei Geltungsstufen.
 *
 * Props:
 *  - value: { mandant_id, course_set }
 *  - onChange: ({ mandant_id, course_set }) => void
 *  - mandanten: Mandantenliste
 *  - courseSets: Kursset-Liste (vom Backend)
 */
export default function ScopeSelect({ value, onChange, mandanten, courseSets }) {
    return (
        <select
            value={encodeScope(value)}
            onChange={(e) => onChange(decodeScope(e.target.value))}
        >
            <option value="">global – gilt für alle Mandanten</option>
            <optgroup label="Kursset">
                {(courseSets || []).map((cs) => (
                    <option key={cs} value={`set:${cs}`}>
                        {courseSetLabel(cs)}
                    </option>
                ))}
            </optgroup>
            <optgroup label="Einzelner Mandant">
                {(mandanten || []).map((m) => (
                    <option key={m.id} value={`mandant:${m.id}`}>
                        {m.name}
                        {m.course_set && m.course_set !== 'Standard' ? ` (${m.course_set})` : ''}
                    </option>
                ))}
            </optgroup>
        </select>
    );
}
